import { render, staticRenderFns } from "./UploadField.vue?vue&type=template&id=60ad1c01&scoped=true"
import script from "./UploadField.vue?vue&type=script&lang=ts"
export * from "./UploadField.vue?vue&type=script&lang=ts"
import style0 from "./UploadField.vue?vue&type=style&index=0&id=60ad1c01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ad1c01",
  null
  
)

export default component.exports